/*eslint-disable*/
class YandexMetrika {
  constructor(trackingId) {
    this._data = [];
    this._metrika = null;
    this.trackingId = trackingId;

    if (window['yaCounter' + this.trackingId]) {
      this._init();
    } else {
      document.addEventListener('yacounter' + this.trackingId + 'inited', this._init.bind(this))
    }
  }

  _call(params) {
    let funcName = params[0] ;
    this._metrika[funcName](...params.slice(1));
  }

  _add() {
    if (this._metrika) {
      this._call(Array.from(arguments));
    } else {
      this._data.push(Array.from(arguments));
    }
  }

  _init() {
    this._metrika = window['yaCounter' + this.trackingId];

    this._data.reverse().forEach(this._call.bind(this));
    this._data = [];
  }

  sendPage(to) {
    this._add('hit', to.fullPath);
  }
}

export default YandexMetrika